module.exports = __webpack_public_path__ + "img/drop_down_arrow_White.a1d65738.svg";